import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import BackgroundSlider from "./BackgroundSlider";
import VideoSection from "./VideoSection";
import './Home.css';
import ProfessionalSlider from "./HerbalSlider";

const Home = () => {
  const [isExploring, setIsExploring] = useState(false);
  const navigate = useNavigate();

  const handleExploreClick = () => {
    setIsExploring(true);
    
    setTimeout(() => {
      navigate('/products');
      setIsExploring(false);
    }, 1000);
  };

  // دالة للعد التصاعدي للأرقام
  const CountingSection = () => {
    const [years, setYears] = useState(0);
    const [products, setProducts] = useState(0);
    const [clients, setClients] = useState(0);
    const countingRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        },
        { threshold: 0.3 }
      );

      if (countingRef.current) {
        observer.observe(countingRef.current);
      }

      return () => {
        if (countingRef.current) {
          observer.unobserve(countingRef.current);
        }
      };
    }, []);

    useEffect(() => {
      if (isVisible) {
        const animateCount = (setter, target, duration = 2000) => {
          let start = 0;
          const startTime = Date.now();
          
          const updateCount = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const current = Math.floor(progress * target);
            
            setter(current);
            
            if (progress < 1) {
              requestAnimationFrame(updateCount);
            }
          };
          
          requestAnimationFrame(updateCount);
        };

        animateCount(setYears, 10);
        animateCount(setProducts, 48);
        animateCount(setClients, 7);
      }
    }, [isVisible]);

    return (
      <section className="counting-section text-center" ref={countingRef}>
        <div className="container">
          <h2 className="hidden">Realm of Herbs</h2>
          <div className="counting-pusher">
            <div className="row">
              <div className="col-md-4 col-sm-6">
                <div className="counting-wrapper">
                  <div className="count-description">
                    <span className="timer">{years}</span>
                    <span className="plus">+</span>
                  </div>
                  <p>Years of experience</p>
                </div>
              </div>
              <div className="col-md-4 col-sm-6">
                <div className="counting-wrapper">
                  <div className="count-description">
                    <span className="timer">{products}</span>
                    <span className="plus">+</span>
                  </div>
                  <p>Our products</p>
                </div>
              </div>
              <div className="col-md-4 col-sm-6">
                <div className="counting-wrapper last-wrapper">
                  <div className="count-description">
                    <span className="timer">{clients}</span>
                    <span className="plus">+</span>
                  </div>
                  <p>Clients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  // قسم الخدمات
  const ServicesSection = () => {
    const servicesRef = useRef(null);
    const [visibleServices, setVisibleServices] = useState([]);

    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const index = parseInt(entry.target.dataset.index);
              setVisibleServices(prev => [...prev, index]);
            }
          });
        },
        { threshold: 0.1 }
      );

      const serviceElements = servicesRef.current?.querySelectorAll('.service-wrapper');
      serviceElements?.forEach(element => {
        observer.observe(element);
      });

      return () => {
        serviceElements?.forEach(element => {
          observer.unobserve(element);
        });
      };
    }, []);

    const services = [
      {
        id: 1,
        icon: "🌱",
        title: "Before Establishing",
        description: "Before establishing we have been working as a supplier of all kinds of organic and non-organic dried seeds and herbs from our own farms to most of the big companies in this field in Egypt."
      },
      {
        id: 2,
        icon: "🤝",
        title: "Minimizing & Flexibility",
        description: "Through our experience gained from diverse and distinct markets to maintain long-term business relationships with customers, the company's sales staff are allowed to apply for various order fulfillment procedures."
      },
      {
        id: 3,
        icon: "👥",
        title: "Social Responsibilities",
        description: "We maintain steady flow by a growing interest of farm pre contracting supported by technical follow up in site to magnify the direct supervision on each production step and refine whole production procedure."
      },
      {
        id: 4,
        icon: "📊",
        title: "Performance Measures",
        description: "Order Fulfillment Efficiency is one of our main indicators highly considered in order to enhance our service; we regularly analyze our performance with respect to percentage achieved annually with heavily consideration of complaints received."
      },
      {
        id: 5,
        icon: "🛒",
        title: "Offer Products",
        description: "What makes us able to offer products with high quality and still at competitive prices is the fact that we have our own farms to get raw materials from. This makes our traceability procedure of all products very easy and accurate."
      },
      {
        id: 6,
        icon: "🔥",
        title: "Steam Sterilization",
        description: "As Realm of Herbs company, we are performs the steam sterilization of spices, oil seeds and all dry food product groups in BRC (British Retail Consortium)."
      }
    ];

    return (
      <section className="service-section section-padding" ref={servicesRef}>
        <div className="container text-center">
          <div className="section-title">
            <h2>Our Services<span className="text-color"></span></h2>
            <p>Realm of Herbs is a leading Egyptian company in the field of producing and exporting aromatic, medicinal herbs, seeds, spices, forage seeds, and legumes.</p>
          </div>
          
          <div className="row">
            {services.map((service, index) => (
              <div key={service.id} className="col-md-4 col-sm-6">
                <div 
                  className={`service-wrapper ${visibleServices.includes(index) ? 'visible' : ''}`}
                  data-index={index}
                >
                  <div className="service-icon">
                    {service.icon}
                  </div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="more-service">
            <Link to="/contact" className="link btn btn-default">All Services</Link>
          </div>
        </div>
      </section>
    );
  };

  return (
    <>

      <div className="hero-section">
        <BackgroundSlider />
        
        <div className="hero-overlay">
          <div className="hero-content">
            <span>Welcome to</span>
            <h1>Realm of Herbs</h1>
            <p>Natural & Organic Herbs, Spices & Seeds</p>
            <button 
              className={`hero-btn ${isExploring ? 'exploring' : ''}`}
              onClick={handleExploreClick}
              disabled={isExploring}
            >
              {isExploring ? 'Exploring...' : 'Explore Products'}
            </button>
          </div>
        </div>
      </div>

      <div className="home-content">
        <VideoSection />
      </div>
      
      <ProfessionalSlider/>
      
      {/* الأقسام المضافة */}
      <ServicesSection />
      <CountingSection />
      
    </>
  );
};

export default Home;